// extracted by mini-css-extract-plugin
export default {"experienceContainer":"styles_experienceContainer__GX9jj","experienceHeader":"styles_experienceHeader__6LKVF","experienceVideo":"styles_experienceVideo__FXsR5"};